import React, { useCallback } from 'react';
import { Override } from 'types';
import CheckboxInput from 'components/ui/form/CheckboxInput';
import useFormInput, { FormInputProps } from './useFormInput';

export type CheckboxFieldProps = Override<
  React.ComponentPropsWithoutRef<typeof CheckboxInput>,
  FormInputProps<boolean, null>
>;

function CheckboxField(props: CheckboxFieldProps): JSX.Element {
  const { value, name, onValueChange, ...otherProps } = useFormInput({
    ...props,
    type: 'checkbox',
  });

  const handleChange = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      if (onValueChange) {
        const { checked } = event.target;
        onValueChange(checked, name);
      }
    },
    [name, onValueChange],
  );

  return (
    <CheckboxInput
      name={name}
      checked={value}
      value={typeof value === 'boolean' ? name : value}
      onChange={handleChange}
      {...otherProps}
    />
  );
}

export default CheckboxField;
